import { Circle } from 'src/api/circles';
import { Pagination } from 'src/api/common';
import api from './baseApi';

export interface Waitlist {
  _id: string;
  createdAt: string;
  updatedAt: string;

  tribe: Circle;
  tribe_id: string;
  user_id: string;
  bid_id: string;
  bid_amount_usd: number;
}

export interface GetWaitlistsResponse {
  result: Waitlist[];
  pagination: Pagination;
}

export const waitlistsApi = {
  getWaitlists: async (): Promise<GetWaitlistsResponse> => {
    const axiosResponse = await api.get(`waitlists`);
    return axiosResponse.data;
  },

  leaveWaitlist: async (waitlist_id: string): Promise<void> => {
    await api.delete(`waitlists/${waitlist_id}`);
  },
};
